<script setup lang="ts">
import MotionList from '@plf/components/shared/motion/MotionList.vue'
import { deleteNotification, notifications } from '@ui/components/notifications/useNotifications'

withDefaults(
  defineProps<{
    bottom?: string
  }>(),
  {
    bottom: '16px',
  },
)
</script>

<template lang="pug">
MotionList.notifications.flex.col-8.w-100p(:x="30")
  UiNotifications(
    v-for="notification of notifications"
    v-bind="notification"
    :key="notification.id"
    @close="deleteNotification(notification.id ?? '')"
  )
</template>

<style scoped>
.notifications {
  bottom: v-bind(bottom);
  right: 16px;

  @screen sm {
    right: 40px;
  }

  max-width: min(374px, calc(100vw - 32px));

  @screen sm {
    max-width: 374px;
  }
}
</style>
